/**
 * DetailClock component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withClock from '@shared/components/utils/hoc/withClock';

/**
 * Styled detail clock.
 */
const DetailClock = styled.span`
  align-items: center;
  color: ${Colors['text']};
  display: flex;
  font-family: ${Fonts['regular']};
  font-size: ${30 * Screen.widthRatio}px;
  margin-right: ${28 * Screen.widthRatio}px;
  text-shadow: ${1 * Screen.widthRatio}px ${1 * Screen.widthRatio}px
    ${4 * Screen.widthRatio}px black;
`;

export default withClock(DetailClock, {
  displaySeconds: false,
});
